module.exports = __webpack_public_path__ + "static/media/spark_logo.08268875.png";